
// import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
// import { useValidateLogin } from './api/setting.api';
// import { notification } from 'antd';

// // Helper function to safely parse JSON
// const safeParseJSON = (value) => {
//   try {
//     if (value && typeof value === 'string') {
//       return JSON.parse(value);
//     }
//     return null;
//   } catch (error) {
//     console.error('JSON parse error:', error, 'Value:', value);
//     return null;
//   }
// };

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [company, setCompany] = useState(safeParseJSON(sessionStorage.getItem('tos-company')));
//   const [loginRole, setLoginRole] = useState(safeParseJSON(sessionStorage.getItem('tos-role')) || []);
//   const [loginUser, setLoginUser] = useState(safeParseJSON(sessionStorage.getItem('tos-user')));
//   const [token, setToken] = useState(sessionStorage.getItem('tos-token') || null);
//   const [loginAdminUser, setLoginAdminUser] = useState(safeParseJSON(sessionStorage.getItem('tos-super')));
//   const [selectedCargo, setSelectedCargo] = useState(sessionStorage.getItem('tos-cargo') || null);

//   const { data: loginUserData, mutate: validateLogin, isSuccess, isError, error } = useValidateLogin();

//   const pathname = window.location.href;

//   // Fetch user data by ID
//   const fetchUser = useCallback(async (userId, authToken) => {
//     if (!userId || !authToken) {
//       console.log('Missing userId or token, skipping fetchUser');
//       return;
//     }

//     try {
//       const response = await fetch(`https://api.synergytoss.net/api/v1/Users/${userId}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${authToken}`,
//           'Cache-Control': 'no-cache',
//           Pragma: 'no-cache',
//           Expires: '0',
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`Fetch user failed: ${response.statusText}`);
//       }

//       const userData = await response.json();
//       console.log('Raw user data:', userData);
//       const roles = userData.roles ? userData.roles.map(role => role.name) : [];
//       const transformedUser = { ...userData, roles };

//       sessionStorage.setItem('tos-user', JSON.stringify(transformedUser));
//       sessionStorage.setItem('tos-role', JSON.stringify(roles));
//       setLoginUser(transformedUser);
//       setLoginRole(roles);
//       console.log('User fetched:', transformedUser);
//     } catch (error) {
//       console.error('Error fetching user:', error);
//       notification.error({ message: `Failed to fetch user data: ${error.message}` });
//     }
//   }, []);

//   // Handle login success and initial user fetch
//   useEffect(() => {
//     console.log('AuthProvider pathname:', pathname);
//     if (pathname.includes('/admin')) {
//       setLoginAdminUser(true);
//       sessionStorage.setItem('tos-super', JSON.stringify(true));
//     } else {
//       setLoginAdminUser(null);
//       sessionStorage.removeItem('tos-super');
//     }

//     if (isSuccess && loginUserData?.data) {
//       const loginData = loginUserData.data;
//       console.log('Login success, raw data:', loginData);

//       const roles = loginData.roles ? loginData.roles.map(role => role.name) : [];
//       const transformedUser = { ...loginData, roles };

//       // Update sessionStorage selectively
//       notification.success({ message: 'Successfully logged in' });

//       sessionStorage.setItem('tos-company', JSON.stringify(loginData.company || null));
//       sessionStorage.setItem('tos-role', JSON.stringify(roles));
//       sessionStorage.setItem('tos-user', JSON.stringify(transformedUser));
//       sessionStorage.setItem('tos-token', loginData.token || '');

//       setCompany(loginData.company || null);
//       setLoginRole(roles);
//       setLoginUser(transformedUser);
//       setToken(loginData.token || null);
//       console.log('Login user set:', transformedUser);

//       // Redirect to /pos/layout if "POS Operator" is in roles
//       if (roles.includes('POS Operator')) {
//         window.location.replace('#/pos/layout');
//       }
//     } else if (isSuccess) {
//       console.error('Login failed: No data returned');
//       notification.error({ message: 'Login failed, check credentials and try again...' });
//     }

//     if (isError) {
//       console.error('Login error:', error);
//       notification.error({ message: 'Check credentials' });
//     }
//   }, [isSuccess, loginUserData, isError, error]);

//   // Fetch user data on app load if token and userId exist
//   useEffect(() => {
//     const storedUser = safeParseJSON(sessionStorage.getItem('tos-user'));
//     const storedToken = sessionStorage.getItem('tos-token');
//     if (storedUser?.id && storedToken) {
//       fetchUser(storedUser.id, storedToken);
//     }
//   }, [fetchUser]);

//   const handleLoginUser = (payload) => {
//     console.log('Attempting login with payload:', payload);
//     validateLogin(payload);
//   };

//   const handleLogoutUser = () => {
//     console.log('Logging out user');
//     setSelectedCargo(null);
//     setCompany(null);
//     setLoginRole([]);
//     setLoginUser(null);
//     setToken(null);
//     setLoginAdminUser(null);

//     sessionStorage.clear();
//     localStorage.clear();

//     window.location.replace('#/login');
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         handleLoginUser,
//         handleLogoutUser,
//         company,
//         setCompany,
//         loginRole,
//         setLoginRole,
//         loginUser,
//         setLoginUser,
//         token,
//         loginAdminUser,
//         setLoginAdminUser,
//         selectedCargo,
//         setSelectedCargo,
//         fetchUser,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuthContext = () => useContext(AuthContext);



import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useValidateLogin } from './api/setting.api';
import { notification, Modal, Card, Row, Col, Button, Typography } from 'antd'; // Added Modal & UI
import { UserOutlined, ShopOutlined } from '@ant-design/icons'; // Added icons

const { Title, Text } = Typography;

// Helper function to safely parse JSON
const safeParseJSON = (value) => {
  try {
    if (value && typeof value === 'string') {
      return JSON.parse(value);
    }
    return null;
  } catch (error) {
    console.error('JSON parse error:', error, 'Value:', value);
    return null;
  }
};

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [company, setCompany] = useState(safeParseJSON(sessionStorage.getItem('tos-company')));
  const [loginRole, setLoginRole] = useState(safeParseJSON(sessionStorage.getItem('tos-role')) || []);
  const [loginUser, setLoginUser] = useState(safeParseJSON(sessionStorage.getItem('tos-user')));
  const [token, setToken] = useState(sessionStorage.getItem('tos-token') || null);
  const [loginAdminUser, setLoginAdminUser] = useState(safeParseJSON(sessionStorage.getItem('tos-super')));
  const [selectedCargo, setSelectedCargo] = useState(sessionStorage.getItem('tos-cargo') || null);

  // ---------- NEW: Role Selection Modal State ----------
  const [showRoleSelection, setShowRoleSelection] = useState(false);
  const [pendingLoginData, setPendingLoginData] = useState(null);
  const [selectedRole, setSelectedRole] = useState(sessionStorage.getItem('tos-preferred-role') || null);
  // ----------------------------------------------------

  const { data: loginUserData, mutate: validateLogin, isSuccess, isError, error } = useValidateLogin();

  const pathname = window.location.href;

  // Fetch user data by ID
  const fetchUser = useCallback(async (userId, authToken) => {
    if (!userId || !authToken) {
      console.log('Missing userId or token, skipping fetchUser');
      return;
    }

    try {
      const response = await fetch(`https://api.synergytoss.net/api/v1/Users/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });

      if (!response.ok) {
        throw new Error(`Fetch user failed: ${response.statusText}`);
      }

      const userData = await response.json();
      console.log('Raw user data:', userData);
      const roles = userData.roles ? userData.roles.map(role => role.name) : [];
      const transformedUser = { ...userData, roles };

      sessionStorage.setItem('tos-user', JSON.stringify(transformedUser));
      sessionStorage.setItem('tos-role', JSON.stringify(roles));
      setLoginUser(transformedUser);
      setLoginRole(roles);
      console.log('User fetched:', transformedUser);
    } catch (error) {
      console.error('Error fetching user:', error);
      notification.error({ message: `Failed to fetch user data: ${error.message}` });
    }
  }, []);

  // ---------- NEW: Role Selection Handlers ----------
  const handleSelectAdmin = () => {
    if (pendingLoginData) {
      sessionStorage.setItem('tos-super', JSON.stringify(true));
      setLoginAdminUser(true);
      setSelectedRole('Admin');
      sessionStorage.setItem('tos-preferred-role', 'Admin'); // Store preference
      // Complete login and redirect
      setCompany(pendingLoginData.company || null);
      setLoginRole(pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : []);
      setLoginUser({ ...pendingLoginData, roles: pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : [] });
      setToken(pendingLoginData.token || null);
      notification.success({ message: 'Successfully logged in as Admin' });
      sessionStorage.setItem('tos-company', JSON.stringify(pendingLoginData.company || null));
      sessionStorage.setItem('tos-role', JSON.stringify(pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : []));
      sessionStorage.setItem('tos-user', JSON.stringify({ ...pendingLoginData, roles: pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : [] }));
      sessionStorage.setItem('tos-token', pendingLoginData.token || '');
      
      setShowRoleSelection(false);
      setPendingLoginData(null);
      
      // Redirect using your existing method
      window.location.replace('#/dashboard/informational');
    }
  };

  const handleSelectPOS = () => {
    if (pendingLoginData) {
      sessionStorage.removeItem('tos-super');
      setLoginAdminUser(null);
      setSelectedRole('POS Operator');
      sessionStorage.setItem('tos-preferred-role', 'POS Operator'); // Store preference
      // Complete login and redirect
      setCompany(pendingLoginData.company || null);
      setLoginRole(pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : []);
      setLoginUser({ ...pendingLoginData, roles: pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : [] });
      setToken(pendingLoginData.token || null);
      notification.success({ message: 'Successfully logged in as POS Operator' });
      sessionStorage.setItem('tos-company', JSON.stringify(pendingLoginData.company || null));
      sessionStorage.setItem('tos-role', JSON.stringify(pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : []));
      sessionStorage.setItem('tos-user', JSON.stringify({ ...pendingLoginData, roles: pendingLoginData.roles ? pendingLoginData.roles.map(r => r.name) : [] }));
      sessionStorage.setItem('tos-token', pendingLoginData.token || '');
      
      setShowRoleSelection(false);
      setPendingLoginData(null);
      
      // Redirect using your existing method
      window.location.replace('#/pos/layout');
    }
  };
  // ------------------------------------------------

  // Handle login success and initial user fetch
  useEffect(() => {
    console.log('AuthProvider pathname:', pathname);
    if (pathname.includes('/admin')) {
      setLoginAdminUser(true);
      sessionStorage.setItem('tos-super', JSON.stringify(true));
    } else {
      setLoginAdminUser(null);
      sessionStorage.removeItem('tos-super');
    }

    if (isSuccess && loginUserData?.data) {
      const loginData = loginUserData.data;
      console.log('Login success, raw data:', loginData);

      const roles = loginData.roles ? loginData.roles.map(role => role.name) : [];
      const transformedUser = { ...loginData, roles };

      // Check for existing preferred role
      const preferredRole = sessionStorage.getItem('tos-preferred-role');

      // ---------- NEW DECISION LOGIC ----------
      const hasAdmin = roles.includes('Admin');
      const hasPOS = roles.includes('POS Operator');

      if (hasAdmin && hasPOS && !preferredRole) {
        // Both roles and no preference -> show modal
        setPendingLoginData(loginData);
        setShowRoleSelection(true);
        return; // Stop here – no redirect yet
      } else if (hasAdmin && hasPOS && preferredRole) {
        // Both roles but user has a preference – redirect accordingly
        if (preferredRole === 'Admin') {
          sessionStorage.setItem('tos-super', JSON.stringify(true));
          setLoginAdminUser(true);
          window.location.replace('#/dashboard/informational');
        } else if (preferredRole === 'POS Operator') {
          sessionStorage.removeItem('tos-super');
          setLoginAdminUser(null);
          window.location.replace('#/pos/layout');
        }
        // Continue with normal login flow below
      } else if (hasPOS && !hasAdmin) {
        // Only POS Operator
        window.location.replace('#/pos/layout');
      } else if (hasAdmin && !hasPOS) {
        // Only Admin
        sessionStorage.setItem('tos-super', JSON.stringify(true));
        setLoginAdminUser(true);
        window.location.replace('#/dashboard/informational');
      } else {
        // No known roles – fallback to dashboard
        window.location.replace('#/dashboard');
      }
      // ----------------------------------------

      // --- Your original sessionStorage and state updates (do this for all cases except modal) ---
      // We move these BEFORE the redirects so state is set.
      notification.success({ message: 'Successfully logged in' });

      sessionStorage.setItem('tos-company', JSON.stringify(loginData.company || null));
      sessionStorage.setItem('tos-role', JSON.stringify(roles));
      sessionStorage.setItem('tos-user', JSON.stringify(transformedUser));
      sessionStorage.setItem('tos-token', loginData.token || '');

      setCompany(loginData.company || null);
      setLoginRole(roles);
      setLoginUser(transformedUser);
      setToken(loginData.token || null);
      console.log('Login user set:', transformedUser);

      // Note: For modal case we return early, so the redirects above are not executed.
      // We'll handle redirect in the modal handlers.
      
    } else if (isSuccess) {
      console.error('Login failed: No data returned');
      notification.error({ message: 'Login failed, check credentials and try again...' });
    }

    if (isError) {
      console.error('Login error:', error);
      notification.error({ message: 'Check credentials' });
    }
  }, [isSuccess, loginUserData, isError, error]);

  // Fetch user data on app load if token and userId exist
  useEffect(() => {
    const storedUser = safeParseJSON(sessionStorage.getItem('tos-user'));
    const storedToken = sessionStorage.getItem('tos-token');
    if (storedUser?.id && storedToken) {
      fetchUser(storedUser.id, storedToken);
    }
  }, [fetchUser]);

  const handleLoginUser = (payload) => {
    console.log('Attempting login with payload:', payload);
    validateLogin(payload);
  };

  const handleLogoutUser = () => {
    console.log('Logging out user');
    setSelectedCargo(null);
    setCompany(null);
    setLoginRole([]);
    setLoginUser(null);
    setToken(null);
    setLoginAdminUser(null);
    setSelectedRole(null);
    setShowRoleSelection(false);
    setPendingLoginData(null);

    sessionStorage.clear();
    localStorage.clear();

    window.location.replace('#/login');
  };

  // ---------- NEW: Role Selection Modal Component ----------
  const RoleSelectionModal = () => (
    <Modal
      open={showRoleSelection}
      onCancel={() => {
        setShowRoleSelection(false);
        setPendingLoginData(null);
      }}
      footer={null}
      closable={false}
      maskClosable={false}
      width={800}
    >
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Title level={3}>Select Your Dashboard</Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: '40px' }}>
          You have access to multiple systems. Please choose where you want to navigate:
        </Text>

        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} sm={12}>
            <Card
              hoverable
              onClick={handleSelectAdmin}
              style={{
                height: '300px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '12px',
                border: '2px solid #1890ff',
                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.15)',
              }}
              bodyStyle={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: '#1890ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
              }}>
                <UserOutlined style={{ fontSize: '40px', color: 'white' }} />
              </div>
              <Title level={4} style={{ marginBottom: '8px' }}>Admin Dashboard</Title>
              <Text type="secondary" style={{ textAlign: 'center', marginBottom: '16px' }}>
                Access the full administrative panel with system management, reporting, and user administration tools.
              </Text>
              <Button type="primary" size="large" icon={<UserOutlined />}>
                Enter as Admin
              </Button>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              hoverable
              onClick={handleSelectPOS}
              style={{
                height: '300px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '12px',
                border: '2px solid #52c41a',
                boxShadow: '0 4px 12px rgba(82, 196, 26, 0.15)',
              }}
              bodyStyle={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: '#52c41a',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
              }}>
                <ShopOutlined style={{ fontSize: '40px', color: 'white' }} />
              </div>
              <Title level={4} style={{ marginBottom: '8px' }}>POS System</Title>
              <Text type="secondary" style={{ textAlign: 'center', marginBottom: '16px' }}>
                Access the Point of Sale interface for processing transactions, managing orders, and handling customer interactions.
              </Text>
              <Button type="primary" size="large" icon={<ShopOutlined />} style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                Enter POS System
              </Button>
            </Card>
          </Col>
        </Row>

        <Text type="secondary" style={{ display: 'block', marginTop: '30px' }}>
          You can switch between systems later from the user menu.
        </Text>
      </div>
    </Modal>
  );
  // --------------------------------------------------------

  return (
    <AuthContext.Provider
      value={{
        handleLoginUser,
        handleLogoutUser,
        company,
        setCompany,
        loginRole,
        setLoginRole,
        loginUser,
        setLoginUser,
        token,
        loginAdminUser,
        setLoginAdminUser,
        selectedCargo,
        setSelectedCargo,
        fetchUser,
        // NEW: expose selectedRole if needed elsewhere
        selectedRole,
        setSelectedRole,
      }}
    >
      {children}
      <RoleSelectionModal />
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);